/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-09-06 13:53:28
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-17 18:30:24
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  DatePicker,
  Checkbox,
  Input,
} from 'antd'
import { unwatchFile } from 'fs'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTenantId, selectChainId, selectChainType } from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import {
  DateRangeType,
  DateSelect,
  getDateRange,
} from '../../../compnents/form/DateSelect'
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnlyOne,
  DateTimeFormatSimpleOnly,
} from '../../../models/datetime'
import { getChainTenantListFn } from '../../chainTransferApplication/chainSlice'
import styles from './EAFConserveRecord.module.css'
export const Query = (props: {
  add: () => void
  onValueChange: (params: any) => void
  export: () => void
  loading?: any
  exportLoading?: any
}): ReactElement => {
  const [form] = Form.useForm()

  const { Option } = Select

  const dispatch = useDispatch<RootDispatch>()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const chainType = useSelector(selectChainType)

  const [chainList, setChainList] = useState<any>([])

  useEffect(() => {
    if (tenantId == chainId) {
      dispatch(getChainTenantListFn())
        .then(unwrapResult)
        .then((res: any) => {
          setChainList(res?.records)
        })
    }
  }, [])

  return (
    <Form
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      autoComplete='off'
      form={form}
      onFinish={(values) => {
        if (!values?.timeHead && values?._dateRange == 6) {
          return
        }
        const startTime = values?.timeHead
          ? moment(values?.timeHead)?.format(DateTimeFormatSimpleOnly)
          : undefined
        const endTime = values?.timeTail
          ? moment(values?.timeTail)?.format(DateTimeFormatSimpleOnly)
          : undefined
        props.onValueChange({
          ...values,
          maintainTimeStart: startTime,
          maintainTimeEnd: endTime,
          timeHead: undefined,
          timeTail: undefined,
        })
      }}
    >
      <Row
        style={{ marginBottom: 10, width: '100%' }}
        align='middle'
        justify='space-between'
      >
        <Space>
          {/* <Form.Item name='' noStyle>
            <Select placeholder='门店名称' allowClear style={{ width: '8rem' }}>
              <Option value={0} key={0}>
                11
              </Option>
            </Select>
          </Form.Item> */}
          <DateSelect
            style={{ width: '8rem' }}
            labelPrefix=''
            placeholder='养护日期'
            namePrefix='time'
            onChange={() => {
              form.submit()
            }}
          />
          <Form.Item name='deviceNumber' noStyle>
            <Input
              allowClear={true}
              placeholder='设备编号'
              style={{ width: '8rem' }}
              onChange={() => {
                form.submit()
              }}
            />
          </Form.Item>
          <Form.Item name='deviceName' noStyle>
            <Input
              allowClear={true}
              placeholder='设备名称'
              style={{ width: '8rem' }}
              onChange={() => {
                form.submit()
              }}
            />
          </Form.Item>
          {(tenantId == chainId && chainType >= 0) ? (
            <Form.Item name='tenantId' noStyle>
              <Select
                placeholder={'选择门店'}
                allowClear
                showSearch
                dropdownClassName={styles.select}
                style={{ width: '16rem' }}
                optionFilterProp='children'
                onChange={form.submit}
              >
                {chainList?.map((v: any, i: any) => {
                  return (
                    <Option value={v.id} key={i}>
                      {v.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : (
            ''
          )}
          <Button
            loading={props?.loading}
            type='primary'
            onClick={() => {
              form.submit()
            }}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Button
            loading={props?.exportLoading}
            type='primary'
            onClick={() => {
              props?.export && props?.export()
            }}
          >
            导出
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
